<template>
  <li class="hidden-md">
    <a :href="('tel:' + getHeaderPhoneNumber)">{{ $filters.formatPhoneNumber(getHeaderPhoneNumber) }}</a>
  </li>
  <li class="header-agent-connect hidden-md hidden-lg">
    <button type="button" aria-label="Connect with an agent" @click="openHotlead" class="btn tertiary small">Connect with an agent</button>
  </li>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: 'mvtHeaderContact',
  emits: ['toggleMenu'],
  inject: ['$eventBus'],
  computed:{
    ...mapGetters('glb', ['getHeaderPhoneNumber']),
  },
  methods: {
    openHotlead() {
      this.$eventBus.$emit('dialog-center', {
        name: 'mvtHotleadForm',
        trigger: this.$options.name,
        opt: {
          hotleadTitle: this.molang('header.HotleadTitle'),
          hotleadSub: this.molang('header.HotleadPara'),
          hotleadType: 'ExpertConsultConsumerGlobalHomePageBottom',
          buttonText: this.molang('header.HotleadButtionCap'),
          showZipcode: true,
        },
      });
    },

  }
};
</script>